"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributesFilter = exports.default = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const attributes_expansion_item_component_1 = require("./attributes-expansion-item.component");
const generic_1 = require("../../../generic");
const localization_1 = require("../../../localization");
const components_1 = require("..");
const sidebar_section_1 = require("../side-bar/sidebar-section");
const AttributesFilter = ({ expansionAttributes, isAttributesLoading, openAttributes, onHeaderClick, onCollapseAll, onExpandAll, className, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const isNoData = !expansionAttributes.length && !isAttributesLoading;
    const isOpenAttributesEmpty = (0, react_1.useMemo)(() => (0, ramda_1.all)((value) => !value, (0, ramda_1.values)(openAttributes)), [openAttributes]);
    const isCollapseAllMode = isNoData || isOpenAttributesEmpty;
    return (react_1.default.createElement(components_1.SidebarSection, { className: className, title: react_1.default.createElement(react_1.default.Fragment, null, t({ key: 'ATTRIBUTES' }), react_1.default.createElement(sidebar_section_1.StyledCollapseAll, { onClick: isCollapseAllMode ? onExpandAll : onCollapseAll }, t({ key: isCollapseAllMode ? 'EXPAND_ALL' : 'COLLAPSE_ALL' }))) }, react_1.default.createElement(generic_1.Loading, { iconOrientation: "right", isLoading: isAttributesLoading, progressSize: 25, showEllipsis: false }), !isAttributesLoading && expansionAttributes.map(({ attributeId, subAttributes, title }) => (react_1.default.createElement(attributes_expansion_item_component_1.AttributesExpansionItem, { key: attributeId, id: attributeId, title: title, items: subAttributes, isOpen: openAttributes[attributeId], onHeaderClick: onHeaderClick })))));
};
const MemoizedAttributesFilter = react_1.default.memo(AttributesFilter);
exports.default = MemoizedAttributesFilter;
exports.AttributesFilter = MemoizedAttributesFilter;
